<script>
import _ from 'lodash'
import moment from 'moment'
import OrgService from '@/request/user/org'
import RecordService from '@/request/record/record'
import GradeProjectService from '@/request/followup/gradeProject'
import FollowupRecordService from '@/request/followup/followupRecord'
import FollowupRecordGradeService from '@/request/followup/followupRecordGrade'
export default {
  name: 'FollowupRecordEdit',
  components: {},
  props: {
    followup: {
      type: Object,
      default () {
        return {}
      }
    },
    frecord: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      saving: false,
      hid: null,
      diseaseRecord: {},
      record: this.frecord || {invalid: 0},
      grades: {},
      projects: [],
      groups: []
    }
  },
  computed: {},
  created: function () {
    this.loadHospital()
    this.loadDiseaseRecord()
  },
  watch: {
    hid () {
      this.listProject()
    },
    followup () {
      if (_.isEmpty(this.followup)) {
        this.hid = null
        this.diseaseRecord = {}
        this.record = {}
        this.grades = {}
      } else {
        this.record = this.frecord || {invalid: 0}
        this.loadHospital()
        this.loadDiseaseRecord()
      }
    }
  },
  methods: {
    loadHospital () {
      if (_.isEmpty(this.followup)) {
        this.hid = null
        return
      }
      OrgService.loadOrg({
        descendantId: this.followup.oid,
        parentTypeSn: 'lx0001001'
      }).then(data => {
        let hospital = data.result || {}
        this.hid = hospital.id || null
      })
    },
    listProject () {
      if (!this.hid) {
        this.groups = []
        this.projects = []
        this.grades = {}
        return
      }
      GradeProjectService.list({
        oid: this.hid
      }).then(res => {
        this.projects = _.clone(res.result || [])
        if (_.isEmpty(this.projects)) {
          return
        }
        _.forEach(this.projects, value => {
          if (_.findIndex(this.groups, {'id': value.gid}) < 0) {
            this.groups.push({
              id: value.gid,
              name: value.gname
            })
          }
          this.$set(this.grades, value.id, {
			id: null,
			fuid: this.followup.id,
			record: this.record.id,
			project: value.id,
			pname: value.name,
			grade: null,
			oid: this.followup.oid
          })
        })
		this.listFollowupRecordGrade()
      })
    },
	listFollowupRecordGrade () {
		if (!this.record || !this.record.id) {
			return
		}
		FollowupRecordGradeService.list({
			record: this.record.id
		}).then(data => {
			data = data.result
			if (data && data.length > 0) {
				_.forEach(data, value => {
					if (_.isEmpty(this.grades[value.project])) {
						this.$set(this.grades, value.project, {
							id: value.id,
							fuid: value.fuid,
							record: value.record,
							project: value.project,
							pname: value.name,
							grade: value.grade,
							oid: value.oid
						})
					} else {
						this.$set(this.grades[value.project], 'id', value.id)
						this.$set(this.grades[value.project], 'grade', value.grade)
					}
				})
			}
		})
	},
    loadDiseaseRecord () {
      if (!this.followup.diseaseRecordId) {
        this.diseaseRecord = {}
        return
      }
      RecordService.load({
        id: this.followup.diseaseRecordId
      }).then(data => {
        if (data.result) {
          this.diseaseRecord = _.cloneDeep(data.result)
        } else {
          this.diseaseRecord = {}
        }
      }).catch(() => {
        this.diseaseRecord = {}
      })
    },
    save () {
      this.saving = true
      if (_.isEmpty(this.followup)) {
        this.saving = false
        return
      }
      let record = _.cloneDeep(this.record)
      record.fuid = this.followup.id
      record.auth = 0
      record.means = '电话随访'
      FollowupRecordService.saveRecord(record).then(res => {
        let data = res.result || {}
        if (_.isEmpty(data)) {
          this.saving = false
          return
        }
        this.record = _.clone(data)
        let ps = []
        _.forEach(this.grades, (value) => {
          if (!value.grade) {
            return
          }
          let item = _.cloneDeep(value)
          item.record = this.record.id
          ps.push(FollowupRecordGradeService.save(item))
        })
        Promise.all(ps).then(() => {
          this.saving = false
          this.$emit('saveDone', this.record)
        }).catch(error => {
          this.$message.error(error || '保存满意度失败')
        }).finally(() => {
          this.saving = false
        })
      }).catch(error => {
        this.saving = false
        this.$message.error(error || '保存随访记录失败')
      })
    },
    invalid (val) {
      if (val === 1 || val === '1') {
        this.$set(this.record, 'content', '无效随访')
      } else {
        this.$set(this.record, 'content', '')
      }
    }
  },
  filters: {
    datetimeFilter (value) {
      if (!value || value === '无') {
        return '无'
      }
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    dateFilter (value) {
      if (!value || value === '无') {
        return '无'
      }
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>

<template>
  <div>
    <div class="patient-info box">
      <el-row :gutter="20">
        <el-col :span="24">
          <span class="lable">科室</span>
          <span class="text">{{diseaseRecord.orgName}}({{diseaseRecord.hname}})</span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <span class="lable">姓名</span>
          <span class="text">{{followup.name}}</span>
        </el-col>
        <el-col :span="8">
          <span class="lable">性别</span>
          <span class="text">{{!!followup.sex && followup.sex % 2 === 0 ? '女' : '男'}}</span>
        </el-col>
        <el-col :span="8">
          <span class="lable">年龄</span>
          <span class="text">{{followup.age || '未知'}}岁</span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <span class="lable">主治医生</span>
          <span class="text">{{diseaseRecord.attendingName || '无'}}</span>
        </el-col>
        <el-col :span="16">
          <span class="lable">诊断</span>
          <span class="text">{{diseaseRecord.diagnoseNames || '无'}}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <span class="lable">入院日期</span>
          <span class="text">{{diseaseRecord.admissionDate | dateFilter}}</span>
        </el-col>
        <el-col :span="8">
          <span class="lable">出院日期</span>
          <span class="text">{{diseaseRecord.leaveTime | dateFilter}}</span>
        </el-col>
        <el-col :span="8">
          <span class="lable">手术日期</span>
          <span class="text">{{diseaseRecord.arrangedStartTime | dateFilter}}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <span class="lable">手机号</span>
          <span class="text" style="color: #409EFF;">{{followup.mobile || '未设置手机号'}}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <span class="lable">随访内容</span>
          <span class="text normal" style="color: #409EFF;">{{followup.inquiry || '无'}}</span>
        </el-col>
      </el-row>
    </div>
    <el-form ref="recordForm" :model="record" :disabled="saving">
      <el-form-item style="padding: 0; margin: 0">
        <el-checkbox v-model="record.invalid" :true-label="1" :false-label="0" @change="invalid">无效随访</el-checkbox>
      </el-form-item>
      <el-form-item prop="content">
        <el-input v-model="record.content" type="textarea" :autosize="{ minRows: 2 }" placeholder="请输入随访结果描述"></el-input>
      </el-form-item>
    </el-form>
    <el-form ref="gradeRef" label-position="left" label-width="80px" inline :model="grades" :disabled="saving" class="clear">
      <el-form-item :label="group.name" class="grade-form-item" style="margin-right: 0;" v-for="group in groups" :key="group.id">
        <template v-for="project in projects">
          <el-form-item :label="project.name" :key="project.id" v-if="project.gid === group.id">
            <el-radio-group v-model="grades[project.id].grade" size="mini">
              <el-radio-button :label="1">良</el-radio-button>
              <el-radio-button :label="2">一般</el-radio-button>
              <el-radio-button :label="3">不良</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </template>
      </el-form-item>
    </el-form>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box {
  padding: 20px 20px 0 20px;
  background: #F2F6FC;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  /*margin-bottom: 10px;*/
}
.box.patient-info {
  padding: 20px;
  /*margin-bottom: 20px;*/
}
.patient-info {
  line-height: 40px;
}
.patient-info .text {
  position: relative;
  font-size: 14px;
}
.patient-info .lable {
  width: 80px;
  text-align: left;
  float: left;
  font-size: 14px;
  color: #909399;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.patient-info span {
  overflow: hidden;  /** 隐藏超出的内容 **/
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 1; /** 显示的行数 **/
  white-space:nowrap;
}
.patient-info span.normal {
  word-break: normal;
  display: block;
}
.grade-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
